<template>
    <v-select
        :options="questionTypes"
        :clearable="false"
        :searchable="false"
        :value="displayValue"
        :placeholder="placeholder"
        :disabled="disabled"
        @input="input"
        @open="open"
        @close="close"
        class="input input-block input-text-center quiz-type-select x-select"
    >
        <template #selected-option="{ label, image }">
            <div class="flex items-center">
                <img class="w-6 h-6" :src="image" :alt="label" />
                <p style="margin: 0" class="shadow-text-none pl-3 font-size-16 font-bold question-type-selected">
                    {{ label }}
                </p>
            </div>
        </template>

        <template #option="{ label, image }">
            <div class="flex items-center">
                <img style="opacity: 0.5" class="w-6 h-6" :src="image" :alt="label" />
                <p style="margin: 0" class="shadow-text-none pl-3 font-size-14 font-bold question-type-item">
                    {{ label }}
                </p>
            </div>
        </template>
    </v-select>
</template>

<script>
export default {
    name: 'XQuestionTypeSelect',

    props: {
        value: {},

        placeholder: {
            type: String
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        displayValue() {
            let selected = this.questionTypes.find(item => item.code == this.value)

            return selected
        }
    },

    data() {
        return {
            questionTypes: [
                {
                    label: this.$t('question_basic'),
                    code: 'basic',
                    image: require('@/assets/images/question-types/basic.png')
                },
                {
                    label: this.$t('question_music'),
                    code: 'music',
                    image: require('@/assets/images/question-types/music.png')
                },
                {
                    label: this.$t('question_reveal'),
                    code: 'reveal_image',
                    image: require('@/assets/images/question-types/reveal_image.png')
                },
                {
                    label: this.$t('question_scale'),
                    code: 'scale_image',
                    image: require('@/assets/images/question-types/scale_image.png')
                },
                {
                    label: this.$t('question_type'),
                    code: 'typing_question',
                    image: require('@/assets/images/question-types/typing_question.png')
                },
                {
                    label: this.$t('question_sorting'),
                    code: 'sorting_list',
                    image: require('@/assets/images/question-types/sorting_list.png')
                },
                {
                    label: this.$t('question_puzzle'),
                    code: 'puzzle',
                    image: require('@/assets/images/question-types/puzzle.png')
                },
                {
                    label: this.$t('question_video'),
                    code: 'video',
                    image: require('@/assets/images/question-types/video.png')
                },
                {
                    label: this.$t('question_hotspot'),
                    code: 'hotspot',
                    image: require('@/assets/images/question-types/hotspot.png')
                },
                {
                    label: this.$t('question_scramble'),
                    code: 'scramble',
                    image: require('@/assets/images/question-types/scramble.png')
                }
            ]
        }
    },

    methods: {
        input(e) {
            this.$emit('input', e)
        },

        open() {
            this.$emit('open')
        },

        close() {
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss">
.question-type-selected,
.question-type-item {
    color: #4c4643;
}

.quiz-type-select {
    .vs__selected {
        padding: 0;
    }

    &.vs--disabled {
        .vs__dropdown-toggle,
        .vs__search,
        .vs__open-indicator {
            background-color: transparent;
        }
    }
}
</style>
